export const COOKIES_NAME = 'clpHeaderFirstName';
export const COOKIES_IS_COMPANY = 'clpHeaderIsCompany';
